import { render, staticRenderFns } from "./LocalidadeParaguai.vue?vue&type=template&id=7ebdaa66&lang=pug"
import script from "./LocalidadeParaguai.vue?vue&type=script&lang=js"
export * from "./LocalidadeParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports